import { Card } from "../ui/card";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const RESOURCES = [
  { key: "ambulanza", label: "Ambulanza" },
  { key: "pattuglia", label: "Pattuglia" },
  { key: "medico", label: "Medico" },
  { key: "infermiere", label: "Infermiere" },
  { key: "soccorritore", label: "Soccorritore" },
];

export const emptyRisorse = () =>
  RESOURCES.reduce((acc, r) => ({ ...acc, [r.key]: { enabled: false, qty: 1 } }), {});

export const Field = ({ label, value, onChange, type = "text", testid, placeholder }) => (
  <div>
    <Label className="nx-label">{label}</Label>
    <Input data-testid={testid} type={type} value={value} placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)} className="mt-1.5" />
  </div>
);

export const Sel = ({ label, value, onChange, options, testid }) => (
  <div>
    <Label className="nx-label">{label}</Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="mt-1.5"><SelectValue placeholder="Seleziona" /></SelectTrigger>
      <SelectContent>
        {options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

export const SEZ = ({ icon: Icon, title, children }) => (
  <Card className="p-6 border-slate-200">
    <div className="flex items-center gap-2 mb-4">
      <Icon className="h-4 w-4 text-primary" />
      <h3 className="font-semibold text-slate-800 text-sm font-heading">{title}</h3>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{children}</div>
  </Card>
);
